import { useAuthContext } from '@oriola-corporation/ecom-portal-auth';
import React from 'react';
import styled from 'styled-components';
import { filterAllowedServices, ServiceInfo } from '../../util/services';
import ServiceItem from './ServiceItem';

export const Services: React.FC = () => {
  const { accessToken } = useAuthContext();
  const serviceState = filterAllowedServices(accessToken);

  return (
    <Container>
      {serviceState &&
        serviceState.map((s: ServiceInfo) => s && <ServiceItem key={s.name} service={s} />)}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  margin: 0 auto;
  flex-flow: row wrap;
  align-content: flex-start;
  position: relative;
`;
